module.exports = {
  title: '产品分类管理',
  route: {
    path: 'platform-goods-manage',
    children: {
      path: 'product-classify-list',
    },
  },
};
